import React from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import PeopleIcon from "@material-ui/icons/People";
import { useHistory } from "react-router-dom";

export const AdminMenuListItems = () => {
  const history = useHistory()

  return (<div>
    <ListItem button component="a" onClick={() => history.push("/activeUsers")}>
      <ListItemIcon>
        <PeopleIcon />
      </ListItemIcon>
      <ListItemText primary="Active Users" />
    </ListItem>
  </div>)
}

